import _ from "lodash";
import React, { useState, useEffect } from "react";
import { Button, CardSelection, EmptyState } from "@toddle-edu/ds-web";
import { NoSearchResultsIllustration } from "@toddle-edu/ds-theme";
import { prepareLoadMoreFeed } from "Utils";
import { useHandleScroll } from "Utils/CustomHooks";
import classes from "./CarouselCards.scss";
import classNames from "classnames";

import { graphql, compose } from "lib/apolloClient";
import { connect } from "react-redux";
import I18nHOC from "UIComponents/I18nHOC";
import Loading from "UIComponents/Loading";
import { getWorkbookTemplateFolderQuery } from "../../modules/WorkbookTemplateQueries";
import { getWorkbookTemplatesFolderFromCache } from "../../modules/WorkbookTemplateGraphqlHelpers";

const styles = {
  listItemStyle: {
    height: 193,
    width: 224,
    padding: 0,
  },
};

const CarouselCards = props => {
  const {
    template,
    templateData,
    setSelectedTemplate,
    setTemplateAttachment,
    selectedTemplate,
    updateFolderId,
    folderId,
    sideBarOptions,
    id,
    t,
    isLoading,
    loadMoreEvents,
    hasNextPage,
    getWorkbookTemplateFolder,
    scrollRef,
    isFetchingMoreData,
    setShowPagniationLoader,
  } = props;
  let label = _.get(template, "label", "");
  const folderTemplate = _.get(templateData, "childrenV2.edges", []);
  const isFolderSelected = folderId != "allTemplates";

  const [numberOfCardsToRender, setNumberOfCardsToRender] = useState();

  const getNumberOfCardsToRender = () => {
    const bodyContainer = scrollRef.current;
    var bodyContainerWidth = bodyContainer?.offsetWidth - 40; // Get the width of the body container and subtract padding
    var numberOfcardsToRender = Math.floor(bodyContainerWidth / 248); // 248 is the width of the card
    setNumberOfCardsToRender(numberOfcardsToRender);
  };
  const debouncedGetNumberOfCardsToRender = _.debounce(
    getNumberOfCardsToRender,
    100
  );
  useEffect(() => {
    window.addEventListener("resize", debouncedGetNumberOfCardsToRender);
    getNumberOfCardsToRender();

    return () => {
      window.removeEventListener("resize", debouncedGetNumberOfCardsToRender);
    };
  }, []);

  if (loadMoreEvents) {
    const getScrollRef = () => {
      return scrollRef.current;
    };

    // eslint-disable-next-line react-hooks/rules-of-hooks
    useHandleScroll({
      networkStatus: getWorkbookTemplateFolder?.networkStatus,
      loadMoreFeed: loadMoreEvents,
      hasNextPage,
      getScrollRef,
    });
    setShowPagniationLoader(isFetchingMoreData);
  }
  const subtitleClass = classNames({
    ["text-body-2"]: true,
    [classes.subtitle]: true,
  });

  const seperatorContainerClass = classNames({
    [classes.seperatorContainer]: !isFolderSelected,
    [classes.selectedCategoryContainer]: isFolderSelected,
  });

  let templates = _.get(template, "childrenV2.edges", []);
  if (isFolderSelected) {
    const folderName = _.find(sideBarOptions, { key: folderId });
    templates = _.get(templateData, "childrenV2.edges", []);
    label = _.get(folderName, "title", "");
    label = label?.props?.children[0]?.props?.children;
  }
  const isTemplateAvailable = !_.isEmpty(templates);

  const noDataComponent = () => {
    return isFolderSelected ? (
      isLoading ? (
        <Loading />
      ) : (
        <EmptyState
          illustration={NoSearchResultsIllustration}
          title={t("common:noResultHeading")}
          subtitle={t("common:no_posts_matching_your_search")}
        />
      )
    ) : null;
  };

  const renderTemplateCard = () => {
    let templateArr, nodes;

    if (!isFolderSelected) {
      templateArr = _.filter(
        _.slice(_.get(template, "childrenV2.edges"), 0, numberOfCardsToRender),
        item => {
          return item?.node;
        }
      );
      nodes = _.map(templateArr, item => {
        return item?.node;
      });
    } else {
      templateArr = _.map(folderTemplate, template => {
        return template;
      });
      nodes = _.map(folderTemplate, item => {
        return item?.node;
      });
    }

    return _.map(nodes, node => {
      const { label, id, attachment } = node;
      const metadata = _.get(attachment, "metadata", {});
      const thumbUrl = _.get(attachment, "thumbUrl", "");
      const { numOfPages } = metadata;
      const subtitle =
        numOfPages > 1
          ? t("common:workbook_page_plural", { count: numOfPages })
          : t("common:workbook_page", { count: numOfPages });
      const subtitleComp = <div className={subtitleClass}>{subtitle} </div>;
      const imgComp = (
        <img src={thumbUrl} className={classes.imageStyle} alt={label} />
      );
      return (
        <div className={classes.cardContainer} key={id}>
          <CardSelection
            title={label}
            type="radio"
            shouldTruncate={true}
            key={id}
            value={id}
            subtitle={subtitleComp}
            containerStyle={styles.listItemStyle}
            image={imgComp}
            style={{
              paddingTop: 8,
              paddingLeft: 12,
              borderTop: "1px solid #EBEBEB",
            }}
            selectedValues={[selectedTemplate]}
            onCardSelectionClick={() => {
              setSelectedTemplate(id), setTemplateAttachment(attachment);
            }}
          />
        </div>
      );
    });
  };

  return isTemplateAvailable ? (
    <div>
      <div className={classes.headingContainer}>
        <div className={"heading-5"}>{label}</div>
        {_.get(templates, "length") > numberOfCardsToRender &&
        !isFolderSelected ? (
          <div className={classes.buttonsContainer}>
            <Button
              variant={"outlined-subtle"}
              key={id}
              onClick={() => updateFolderId(id)}
              size={"small"}
              testId={"workbook-workbookTemplate-updateFolderId"}
            >
              {t("community:see_all")}
            </Button>
          </div>
        ) : null}
      </div>
      <div className={seperatorContainerClass}>{renderTemplateCard()}</div>

      {!isFolderSelected ? <div className={classes.seperator} /> : null}
    </div>
  ) : (
    noDataComponent()
  );
};
const mapActionCreators = {};

const templateFolderFilters = {
  types: "ORGANIZATION_RESOURCE",
  portalType: "RESOURCE_LIBRARY",
  first: 24,
  states: ["PUBLISHED"],
};

const mapStateToProps = (state, ownProps) => {
  const folderId = _.get(ownProps, "folderId", "");
  const searchText = _.get(ownProps, "searchText", "");
  return {
    folderId,
    isLoading: false,
    isData: true,
    templateFolderFilters: {
      ...templateFolderFilters,
      id: folderId,
      searchText,
    },
    searchText,
  };
};

export default compose(
  I18nHOC({ resource: ["common"] }),
  connect(mapStateToProps, mapActionCreators),
  graphql(getWorkbookTemplateFolderQuery, {
    name: "getWorkbookTemplateFolder",
    skip: ({ folderId }) => {
      return folderId == "allTemplates" || folderId == "";
    },
    options: ({ templateFolderFilters }) => ({
      fetchPolicy: "cache-and-network",
      variables: {
        ...templateFolderFilters,
      },
    }),
    props({
      getWorkbookTemplateFolder,
      ownProps: { isData, isLoading, templateFolderFilters },
    }) {
      const data = getWorkbookTemplatesFolderFromCache({
        ...templateFolderFilters,
      });
      const templateData = _.get(data, "node", []);
      const endCursor = _.get(
        templateData,
        "childrenV2.pageInfo.endCursor",
        ""
      );
      return {
        onPusherEventTriggered: () => getWorkbookTemplateFolder.refetch(),
        templateData,
        getWorkbookTemplateFolder,
        isData: !_.isEmpty(templateData) && isData,
        isFetchingMoreData: getWorkbookTemplateFolder["networkStatus"] == 3,
        isLoading:
          getWorkbookTemplateFolder["networkStatus"] == 1 ||
          getWorkbookTemplateFolder["networkStatus"] == 2 ||
          isLoading,
        hasNextPage: _.get(
          templateData,
          "childrenV2.pageInfo.hasNextPage",
          false
        ),
        loadMoreEvents: prepareLoadMoreFeed({
          variables: {
            ...templateFolderFilters,
            after: endCursor,
          },
          queryData: getWorkbookTemplateFolder,
          key: "childrenV2",
        }),
      };
    },
  })
)(CarouselCards);
